// Auto-split from i18n.js — language: id
export default {
    translation: {
        // routes & menus
        Dashboard: 'Overview',
        'Space Data': 'Data Ruang',
        'Equipment Data': 'Data Perangkat',
        'Meter Data': 'Data Meter',
        'Tenant Data': 'Data Tenant',
        'Store Data': 'Simpan Data',
        'Shopfloor Data': 'Data Workshop',
        'Combined Equipment Data': 'Data Perangkat Kombinasi',
        'Auxiliary System': 'Sistem Bantuan',
        Microgrid: 'Microgrid',
        'Energy Storage Power Station': 'Stasiun Daya',
        'Photovoltaic Power Station': 'Stasiun Daya',
        'Fault Alarm': 'Alarm Cacat',
        Monitoring: 'Monitor Peralatan',
        'Advanced Reporting': 'Laporan Lanjutan',
        'Knowledge Base': 'Dasar Pengetahuan',
        'Energy Category Data': 'Analis Klasifikasi Konsumsi Energi',
        'Energy Item Data': 'Analis Pembatasan Konsumsi Energi',
        Carbon: 'Emisi CO2',
        Cost: 'Analisis Biaya',
        Output: 'Analis Keluaran',
        Income: 'Analisi Pendapatan',
        Efficiency: 'Analis Efisiensi',
        Load: 'Analisi Muat',
        Statistics: 'Analisis Statistik',
        'Batch Analysis': 'Analisi Seri',
        Saving: 'Analis Penyimpanan EnergiⒺ',
        Plan: 'RencanaⒺ',
        Prediction: 'PredictionⒺ',
        'Production': 'Production',
        'Space Production': 'Space Production',
        'Equipment Tracking': 'Buku Peralatan',
        'Equipment Comparison': 'Perbandingan Peralatan',
        'Shopfloor Comparison': 'Perbandingan Peralatan',
        'Store Comparison': 'Perbandingan Peralatan',
        'Space Comparison': 'Perbandingan Peralatan',
        'Combined Equipment Comparison': 'Perbandingan Peralatan',
        'Tenant Comparison': 'perbandingan penyewa',
        'Environment Monitor': 'Monitoring Lingkungan',
        'Meter Energy': 'Analis Konsumsi Energi Dari Meter',
        'Meter Prediction': 'Prediksi MeterⒺ',
        'Virtual Meter Prediction': 'Prediksi Meter VirtualⒺ',
        'Offline Meter Prediction': 'Prediksi Meter OfflineⒺ',
        'Meter Carbon': 'Meter Emisi CO2',
        'Meter Cost': 'Analisi Biaya Tabel Pengukuran',
        'Meter Trend': 'Analisi Trend Meters',
        'Meter Realtime': 'Analisis Waktu Nyata Dari Meter Pengukuran',
        'Meter Saving': 'Analisis Penyimpanan Energi Dari Ukuran MeterⒺ',
        'Meter Plan': 'Rencana MeteranⒺ',
        'Master Meter Submeters Balance': 'Analisi Bilansi Tabel Skor Total',
        'Meter Batch Analysis': 'Analisis Seri Dari Meter Pengukuran',
        'Meter Comparison': 'Analisi Komparatif Dari Meter Ukuran',
        'Meter Tracking': 'Pemberi Tabel Keukuran',
        'Virtual Meter Saving': 'Analis Menyimpan Energi Tabel VirtualⒺ',
        'Virtual Meter Plan': 'Paket Meteran VirtualⒺ',
        'Virtual Meter Energy': 'Analis Konsum Energi Tabel Virtual',
        'Virtual Meter Carbon': 'Emisi CO2 Meter Virtual',
        'Virtual Meter Cost': 'Analisi Biaya Tabel Virtual',
        'Virtual Meter Batch Analysis': 'Analisi Batch Tabel Virtual',
        'Virtual Meter Comparison': "Perbandingan Meter Virtual",
        'Offline Meter Energy': 'Analis Konsum Energi Jadual Offline',
        'Offline Meter Carbon': 'Emisi Meter CO2 Offline',
        'Offline Meter Cost': 'Analisi Biaya Tabel Offline',
        'Offline Meter Batch Analysis': 'Analisi Batch Tabel Offline',
        'Offline Meter Saving': 'Analis Penyimpanan Energi Dari Tabel OfflineⒺ',
        'Offline Meter Plan': 'Paket Pengukur OfflineⒺ',
        'Offline Meter Input': 'Entri Data Tabel Offline',
        'Tenant Bill': 'Pembayaran Sengaja',
        'Energy Flow Diagram': 'Diagram Aliran Energi',
        'Distribution System': 'Sistem Distribusi Listrik',
        'SVG System': 'Sistem Visualisasi Konfigurasi',
        'Faults Data': 'Analisis Kesalahan',
        'Space Equipments': 'Peralatan Ruang',
        'Combined Equipments': 'Peralatan Kombinasi',
        'Energy Storage Power Station List': 'List',
        'Energy Storage Power Station Details': 'Details',
        'Energy Storage Power Station Reporting': 'Reporting',
        'Energy Storage Power Station Alarm': 'Alarm',
        'Energy Storage Power Station Maintenance': 'Maintenance',
        'Enter Production': 'Enter Production',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
        'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
        'Multiple Energy Storage Power Stations List': 'List',
        'Single Energy Storage Power Station': 'Single Power Station',
        'Single Energy Storage Power Station Dashboard': 'Dashboard',
        'Single Energy Storage Power Station Details': 'Details',
        'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
        'Energy Storage Power Station Reports': 'Power Station Reports',
        'Energy Storage Power Station Reports Energy': 'Energy',
        'Energy Storage Power Station Reports Revenue': 'Revenue',
        'Energy Storage Power Station Reports Parameters': 'Parameters',
        'Photovoltaic Power Station List': 'Power Station List',
        'Photovoltaic Power Station Details': 'Details',
        'Photovoltaic Power Station Reporting': 'Reporting',
        'Photovoltaic Power Station Alarm': 'Alarm',
        'Photovoltaic Power Station Maintenance': 'Maintenance',
        'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
        'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
        'Multiple Photovoltaic Power Stations List': 'List',
        'Single Photovoltaic Power Station': 'Single Power Station',
        'Single Photovoltaic Power Station Dashboard': 'Dashboard',
        'Single Photovoltaic Power Station Details': 'Details',
        'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
        'Photovoltaic Power Station Reports': 'Power Station Reports',
        'Photovoltaic Power Station Reports Energy': 'Energy',
        'Photovoltaic Power Station Reports Revenue': 'Revenue',
        'Photovoltaic Power Station Reports Parameters': 'Parameters',
        'Work Order': 'Work Order',
        'Work Order Installation': 'Installation',
        'Work Order Repair': ' Repair',
        'Work Order Inspection': 'Inspection',
        'Total Number of Work Orders': 'Jumlah Total Perintah Kerja',
        'Number of New Work Orders': 'Jumlah Perintah Kerja Baru',
        'Number of Inprogress Work Orders': 'Jumlah Perintah Kerja yang Sedang Diproses',
        'Number of Done Work Orders': 'Jumlah Perintah Kerja yang Selesai',
        'Fuel Indicator': 'Konsum bahan bakar',
        'Charge Energy Indicator': 'Energi Pengisian Daya',
        'Discharge Energy Indicator': 'Energi Pembuangan Daya',
        'Charge Cost Indicator': 'Biaya Pengisian Daya',
        'Discharge Revenue Indicator': 'Pendapatan Pembuangan Daya',
        'HVAC': 'HVAC',
        'Fire Control': 'Pengendalian Kebakaran',
        'Store Dashboard': 'Dasbor Toko',
        'Comprehensive overview of store energy performance': 'Tinjauan komprehensif kinerja energi toko',
        'Total Stores': 'Total Toko',
        'Total Area': 'Total Area',
        'Active Meters': 'Meter Aktif',
        'Active Alerts': 'Peringatan Aktif',
        'Total Energy Consumption': 'Total Konsumsi Energi',
        'Carbon Emissions': 'Emisi Karbon',
        'Current Period': 'Periode Saat Ini',
        'Energy Consumption by Category': 'Konsumsi Energi per Kategori',
        'Cost Distribution by Category': 'Distribusi Biaya per Kategori',
        'Monthly Energy & Cost Trends': 'Tren Energi dan Biaya Bulanan',
        'Top 5 Energy Consuming Stores': '5 Toko dengan Konsumsi Energi Tertinggi',
        'Energy Category Details': 'Detail Kategori Energi',
        'Store Performance Overview': 'Ringkasan Kinerja Toko',
        'YoY Change': 'Perubahan Tahunan',
        'Per m²': 'Per m²',
        'Usage Intensity': 'Intensitas Penggunaan',
        'Dashboard data loaded successfully': 'Data dasbor berhasil dimuat',
        'Failed to load dashboard data': 'Gagal memuat data dasbor',
        'Store Name': 'Nama Toko',
        'Store Area': 'Area Toko',
        'Energy Consumption': 'Konsumsi Energi',
        'Consumption': 'Konsumsi',
        'last period': 'periode sebelumnya',
        // Tenant Dashboard
        'Tenant Dashboard': 'Dasbor Penyewa',
        'Comprehensive overview of tenant energy performance': 'Gambaran komprehensif kinerja energi penyewa',
        'Total Tenants': 'Total Penyewa',
        'Tenant Performance Overview': 'Gambaran Kinerja Penyewa',
        'Tenant Name': 'Nama Penyewa',
        'Tenant Area': 'Area Penyewa',
        'Tenant Type': 'Jenis Penyewa',
        // Equipment Dashboard
        'Equipment Dashboard': 'Dasbor Peralatan',
        'Total Equipments': 'Total Peralatan',
        'Equipment Performance Overview': 'Ikhtisar Kinerja Peralatan',
        'Equipment Name': 'Nama Peralatan',
        'Equipment Type': 'Jenis Peralatan',
        'Total Energy': 'Total Energi',
        'Total Sensors': 'Total Sensor',
        'Increment Rate': 'Tingkat Kenaikan',

        // Shopfloor Dashboard
        'Total Shopfloors': 'Total bengkel',
        'Shopfloor Performance Overview': 'Ikhtisar kinerja bengkel',
        'Shopfloor Name': 'Nama bengkel',
        'Shopfloor Area': 'Area bengkel',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Total Peralatan Kombinasi',
        'Combined Equipment Performance Overview': 'Ikhtisar Kinerja Peralatan Kombinasi',
        'Combined Equipment Name': 'Nama Peralatan Kombinasi',
        'Associated Equipments': 'Peralatan Terkait',
        // Dashboard
        'Welcome to QiXuan': 'Selamat Datang Di QiXuan',
        'An Industry Leading Energy Management System':
            'Industri Memimpin Sistem Manajemen Energi',
        "This Year's Consumption CATEGORY VALUE UNIT": 'Konsum Tahun Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": 'Biaya Tahun Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": 'Konsum Bulan Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Month's Costs CATEGORY VALUE UNIT": 'Biaya Bulan Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
            'Konsum Selama Periode Yang Sama Tahun Lalu {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
            'Biaya Untuk Periode Yang Sama Tahun Lalu {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} Konsum {{UNIT}}',
        'CATEGORY Costs UNIT': '{{CATEGORY}} Biaya {{UNIT}}',
        // Entities
        Space: 'Ruang',
        Equipment: 'Peralatan',
        Meter: 'Gauges',
        'Offline Meter': 'Jadual Offline',
        'Virtual Meter': 'Tabel Virtual',
        Tenant: 'Penyewa',
        Store: 'Toko',
        Shopfloor: 'Workshop',
        'Combined Equipment': 'Peralatan Kombinasi',
        'Cost Center': 'Pusat Biaya',
        Name: 'Nama',
        DisplayName: 'Tampilkan Nama',
        UserName: 'Nama Pengguna',
        Description: 'Deskripsikan',
        'Energy Category': 'Klasifikasi Energi',
        'Child Spaces': 'Subspace',
        'Associated Equipment': 'Peralatan Yang Berhubungan',
        //Energy Categories
        Electricity: 'Listrik',
        Water: 'Water Tap',
        'Natural Gas': 'Gas Alami',
        // SidePanelModal
        Settings: 'Mengatur',
        'Set your own customized style': 'Tetapkan Gaya Suai Anda',
        'Color Scheme': 'Skema Warna',
        'Choose the perfect color mode for your app': 'Pilih Mode Warna Ideal Untuk Aplikasi Anda',
        Light: 'Warna Cerah',
        Dark: 'Gelap',
        'RTL Mode': 'Mod RTL',
        'Switch your language direction': 'Ubah Arah Bahasa Anda',
        'Fluid Layout': 'Bentangan Aliran',
        'Toggle container layout system': 'Tukar Sistem Bentangan Kontainer',
        'Navigation Position': 'Lokasi Bar Navigasi',
        'Vertical': 'Vertikal',
        'Top': 'Atas',
        'Combo': 'Kombinasi',
        'Transparent': 'Transparan',
        'Inverted': 'Terbalik',
        'Card': 'Kartu',
        'Vibrant': 'Hidup',
        'Select a suitable navigation system for your web application':
            'Pilih Sistem Bar Navigasi Yang Sesuai Untuk Aplikasi Web Anda',
        'Vertical Nav': 'Bar Navigasi Vertikal',
        'Top Nav': 'Bar Navigasi Atas',
        'Vertical Navbar Style': 'Gaya Bar Navigasi Vertikal',
        'Switch between styles for your vertical navbar': 'Tukar Gaya Bar Navigasi Vertikal',
        Language: 'Bahasa',
        'Switch between languages': 'Tukar Bahasa',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'Saya Suka Sistem Ini?',
        'Get QiXuan now': 'Dapatkan QiXuan Sekarang',
        Purchase: 'Enterprise Edition',
        ContactInfo: 'Informasi Kontak',
        ProductWebsite: 'Situs Web Produk',
        CompanyWebsite: 'Situs Web Perusahaan',
        SalesPhone: 'Telepon Penjualan',
        // Query Panels
        'Base Period Begins': 'Mulai Periode Benchmark',
        'Base Period Ends': 'Akhir Periode Benchmark',
        'Comparison Types': 'Compare Types',
        'Year-Over-Year': 'Tahun lalu-tahun',
        'Month-On-Month': 'Bulan Pada Bulan',
        'Free Comparison': 'Rasio Kebebasan',
        'None Comparison': 'Tidak Dibandingkan Dengan',
        'Reporting Period Begins': 'Mulai Periode Laporan',
        'Reporting Period Ends': 'Akhir Periode Laporan',
        '(Optional)': '(Opsional)',
        'Period Types': 'Skala Waktu',
        Yearly: 'Tahun',
        Monthly: 'Bulan',
        Weekly: 'Minggu',
        Daily: 'Hari',
        Hourly: 'Jam',
        Submit: 'Kirim',
        'Input Energy Category': 'Klasifikasi Konsumsi Energi',
        'Output Energy Category': 'Klasifikasi Energi Keluaran',
        'Fraction Parameter': 'Parameter Fraksi',
        Search: 'Cari',
        //DateRangePicker
        sunday: 'Minggu',
        monday: 'Senin',
        tuesday: 'Selasa',
        wednesday: 'Rabu',
        thursday: 'Kamis',
        friday: 'Jumat',
        saturday: 'Sabtu',
        ok: 'Konfirmasi',
        today: 'Hari Ini',
        yesterday: 'Kemarin',
        hours: 'Jam',
        minutes: 'Cabang',
        seconds: 'Detik',
        last7Days: 'Tujuh Hari Terakhir',
        tomorrow: 'Besok',
        dayAfterTomorrow: 'Lusa',
        next7Days: '7 Hari Berikutnya',
        'Select Date Range': 'Pilih Jangkauan Tanggal',
        //Card Summaries and Line Charts
        'Base Period': 'Periode Dasar',
        'Reporting Period': 'Periode Laporan',
        'Per Unit Area': 'Nilai Area Unit',
        'Per Capita': 'Per Capita',
        'Per Unit Production': 'Nilai Produk Unit',
        Baseline: 'Nilai Garis Dasar',
        Actual: 'Nilai Sebenarnya',
        'Baseline Value - Actual Value': 'Nilai Garis Dasar - Nilai Sebenarnya',
        'Average Load': 'Bekas Rata-rata',
        'Maximum Load': 'Muat Maksimum',
        'Load Factor': 'Faktor Muat',
        'Ratio of Average Load to Maximum Load': 'Rasio Dari Beban Rata-rata Ke Beban Maksimum',
        'Carbon Dioxide Emissions by Energy Category': 'Proporci Emisi Dioksida Karbon',
        'Costs by Energy Category': 'Proporci Biaya',
        'Incomes by Energy Category': 'Proporci Pendapatan',
        'Electricity Consumption by Time-Of-Use': 'Konsum Daya Berbagi Waktu',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Waktu Berbagi Emisi Listrik Karbon Dioksida',
        'Electricity Cost by Time-Of-Use': 'Waktu Berbagi Biaya Listrik',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Proporci Konsumsi Yang Ditentukan',
        'Ton of Standard Coal by Energy Category': 'Proporci Ton Coal Standard (TCE)',
        'Ton of Carbon Dioxide Emissions by Energy Category': 'Proporci Ton Emisi Carbon Dioxide (TCO2E)',
        'Reporting Period Consumption CATEGORY UNIT': 'Konsum Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{EQUIPMENT}} Konsum Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Konsum Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'Konsum Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'Konsum Periode Dasar {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT': 'Konsum Selama Periode Laporan {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
            'Konsum Selama Periode Laporan {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT':
            'Konsum Periode Dasar {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': 'Proporci Klasifikasi Subspace {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'Proporci Total Subspace',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
            'Emisi Dioksida Karbon Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Emisi Dioksida Karbon Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Emisi Dioksida Karbon Selama Periode Dasar {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'Biaya Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'Biaya Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'Biaya Peristiwa Dasar {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'Output Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{EQUIPMENT}} Output Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Output Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': 'Output Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'Output Periode Benchmark {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'Daftar Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'Daftar Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'Daftar Periode Dasar {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'Total Pendapatan Selama Periode Laporan {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT':
            'Efisiensi Berkumpul Selama Periode Laporan {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
            '{{EQUIPMENT}} Efisiensi Berkumpul Selama Periode Laporan {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Efisiensi Komprensif Berkumpul Selama Periode Laporan {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Efisiensi Komprensif Berkumpul Selama Periode Laporan {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Efisiensi Komprensif Berkumpul Selama Periode Benchmark {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'Efisiensi Segera {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Efisiensi Segera {{UNIT}}',
        'Equipment Efficiency Indicator': 'Indikator Efisiensi Energi Peralatan',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Efisiensi Komprensif Instan {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT':
            'Efisiensi Berkumpul Selama Periode Laporan {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
            'Efisiensi Berkumpul Selama Periode Laporan {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'Efisiensi Kumulatif Periode Dasar {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT':
            'Efisiensi Kumulatif Periode Dasar {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'Periode Dasar {{CATEGORY}} Muat Maksimum {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'Periode Laporan {{CATEGORY}} Muat Maksimum {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': 'Periode Laporan {{CATEGORY}} Bekas Rata-rata {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'Periode Laporan {{CATEGORY}} Faktor Muat',
        'Base Period CATEGORY Average Load VALUE UNIT': 'Periode Dasar {{CATEGORY}} Bekas Rata-rata {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'Periode Laporan {{CATEGORY}} Nilai Rata-rata {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'Periode Laporan {{CATEGORY}} Nilai Maksimum {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'Periode Laporan {{CATEGORY}} Nilai Minimum {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'Periode Laporan {{CATEGORY}}  Maksudnya Aritmetik {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': 'Periode Laporan {{CATEGORY}} Median {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'Periode Laporan {{CATEGORY}} Abaikan Standar Sampel {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'Periode Laporan {{CATEGORY}} Variasi Sampel {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
            'Penyimpanan Selama Periode Laporan {{CATEGORY}} (Baseline-Sebenar) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
            'Pengurangan Dalam Periode Laporan {{CATEGORY}} (Baseline-Sebenar) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT':
            'Penyimpanan Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'Penyelamatan Peristiwa Benchmark {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT':
            'Total Konsum Tabel Selama Period Laporan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
            'Total Konsum Tabel Selama Period Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT':
            'Konsum Menurut Tabel Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
            'Konsum Menurut Tabel Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'Perbedaan Periode Laporan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'Percentage Perbedaan Selama Periode Laporan',
        'Reporting Period Difference CATEGORY VALUE UNIT': 'Perbedaan Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Trend Values': 'Nilai Perkembangan',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'Daftar Gagal',
        'Reporting Period Number of Fault VALUE': 'Jumlah Kesalahan Selama Periode Laporan: {{VALUE}}',
        'All Faults': 'Semua Kesalahan',
        'Space Faults': 'Kesalahan Ruang',
        'Number of All Faults': 'Jumlah Total Kesalahan',
        'Number of Space Faults': 'Jumlah Kesalahan Ruang',
        'Total Number of Faults': 'Total Number of Faults',
        'Number of New Faults': 'Number of New Faults',
        'Number of Inprogress Faults': 'Number of Inprogress Faults',
        'Number of Done Faults': 'Number of Done Faults',
        //Data Panels
        'Ton of Standard Coal': 'Ton Batubara Standar',
        'Ton of Carbon Dioxide Emissions': 'Ton Emisi Dioksida Karbon',
        'Carbon Emissions Per Unit Of Energy Consumption': 'Emisi karbon per unit konsumsi energi',
        'Operating Characteristic Curve': 'kurva karakteristik operasi',
        Tariff: 'Kadar',
        'Detailed Data': 'Data Rincian',
        'Child Spaces Data': 'Data Subspace',
        'Associated Equipment Data': 'Data Peralatan Terhubung',
        'This Year': 'Tahun Ini',
        'The Same Period Last Year': 'Periode Yang Sama Tahun Lalu',
        'This Month': 'Bulan Ini',
        'This Day': 'Hari Ini',
        Total: 'Total',
        'No data found': 'Tidak Ada Data',
        Export: 'Eksport',
        'AI Analysis': 'Analisis AI',
        Datetime: 'Waktu Tarikh',
        'Time-Of-Use Type': 'Jenis Berbagi Waktu',
        'Top-Peak': 'Tip',
        'On-Peak': 'Puncak',
        'Mid-Peak': 'Flat',
        'Off-Peak': 'Lembah',
        'Deep': 'Deep-Valley',
        Percentage: 'Persentase',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'Tenderasi Titik Konsumsi Energi Dalam Jam Terakhir',
        Circuit: 'Loop',
        Point: 'Titik Data',
        'Realtime Value': 'Nilai Waktu Nyata',
        //Meter Tracking
        'Meter List': 'Daftar Meter Ukuran',
        'Edit Meter': 'Edit',
        'Start Value': 'Nilai Awal',
        'End Value': 'Nilai Akhir',
        'Difference Value': 'Perbedaan',
        'Start Integrity Rate': 'Memulai Tingkat Integritas Data(%)',
        'End Integrity Rate': 'Tingkat Integritas Data Akhir(%)',
        'Full Integrity Rate': 'Tingkat Integritas Data Umum(%)',
        'Start Integrity Rate Description': 'Tingkat Integritas Data Awal: Proporsi meter yang berhasil mendapatkan pembacaan konsumsi energi pada waktu awal dari semua meter selama periode statistik',
        'End Integrity Rate Description': 'Tingkat Integritas Data Akhir: Proporsi meter yang berhasil mendapatkan pembacaan konsumsi energi pada waktu akhir dari semua meter selama periode statistik',
        'Full Integrity Rate Description': 'Tingkat Integritas Data Lengkap: Proporsi meter yang berhasil mendapatkan pembacaan konsumsi energi pada waktu awal dan akhir dari semua meter selama periode statistik',
        //Equipment Tracking
        'Equipment List': 'Daftar Peranti',
        'Edit Equipment': 'Edit',
        //Profile Dropdown
        Feedback: 'Feedback',
        'Account Settings': 'Pengaturan Akaun',
        Logout: 'Keluar',
        //Authentication
        'Log in': 'Login',
        'Email address': 'Alamat Surel',
        'Phone Number': 'Nomor telepon',
        Password: 'Sandi',
        CaptchaCode: 'Kode Verifikasi',
        Refresh: 'Segar',
        'Remember me': 'Ingat Aku',
        'Logged in as ': 'Daftar Masuk ',
        'Forgot Password?': 'Lupakan Kata Sandi?',
        'Forgot your password?': 'Lupakan Kata Sandimu?',
        "Enter your email and we'll send you a reset link":
            'Masukkan Alamat Email Dan Kami Akan Mengirimkan Anda Link Reset',
        "Enter your email and we'll send you a registration link":
            'Masukkan Alamat Email Dan Kami Akan Mengirimkan Link Pendaftaran',
        'Reset Password': 'Reset Kata Sandi',
        'Thanks for using QiXuan!': 'Terima Kasih Telah Menggunakan QiXuan!',
        'You are now successfully signed out': 'Anda Berhasil Keluar',
        'Return to Login': 'Kembali Ke Daftar Masuk',
        'Please check your email!': 'Silakan Periksa Email Anda!',
        'An email has been sent to ': 'Email Telah Dikirim Ke ',
        'Please click on the included link to reset your password':
            'Silakan Klik Pada Link Di Dalam untuk Reset Kata Sandi Anda',
        'Please click on the included link to register your account':
            'Silakan Klik Pada Link Di Dalam Untuk Mendaftar Rekening Anda',
        'An email with password reset link is sent to ':
            'Sebuah Email Yang Mengandung Sambungan Reset Kata Sandi Telah Dikirim Ke ',
        'Change Password': 'Ubah Kata Sandi',
        'Old Password': 'Kata Sandi Asal',
        'New Password': 'Kata Sandi Baru',
        'Confirm Password': 'Ulangi Kata Sandi Baru',
        'Update Password': 'Kemaskini Kata Sandi',
        'Password has been changed!': 'Kata Sandi Telah Diubah!',
        'Verification code has been sent to your inbox. \
  Please copy it to the input box below.':
            'Kode Verifikasi Telah Dikirim Ke Kotak Masuk Anda. Silakan Salin Ke Kotak Masukan Di Bawah。',
        'New to QiXuan': 'Penggunaan Awal QiXuan',
        'Create an account': 'Daftar Rekening',
        'EMAIL Account registration successful': '{{EMAIL}}Reġistrasi Rekening Berhasil',
        'Thanks for verifying your account!': 'Terima Kasih Sudah Memeriksa Rekening Anda！',
        'Your code is': 'Kode Anda Adalah',
        'Send verification code': 'Kirim Kode Verifikasi',
        'Please wait for NUMBER seconds': 'Silakan Berdiri{{NUMBER}}Detik',
        'Password reset': 'Reset Kata Sandi',
        'Please wait for approval': 'Silakan Tunggu Ulang',
        //notification
        Notifications: 'Notis',
        'Mark all as read': 'Set Semua Sebagai Baca',
        'View all': 'Seluruh',
        'Notification New': 'BaruNew',
        'Notification Earlier': 'Sebelumnya',
        'Notification List': 'Senarai Notifikasi',
        'Bulk actions': 'Operasi Seri',
        'Notification Subject': 'Tema',
        'Notification Created Datetime': 'Tanggal Waktu Dibuat',
        'Notification Message': 'Isi',
        'Notification Priority': 'Prioritas',
        'Notification Status': 'Keadaan',
        'Notification Mark As Read': 'Tanda Sebagai Baca',
        'Notification Mark As Acknowledged': 'Konfirmasi',
        'Notification Low': 'Rendah',
        'Notification Medium': 'Dalam',
        'Notification High': 'Tinggi',
        'Notification Critical': 'Serius',
        'Notification Unread': 'Belum Dibaca',
        'Notification Read': 'Baca',
        'Notification Acknowledged': 'Dikonfirmasi',
        'Notification Archive': 'Arkib',
        'Notification Delete': 'Hapus',
        'Notification Apply': 'Aplikasi',
        'Notification Start Datetime': 'Mulai Tanggal Waktu',
        'Notification End Datetime': 'Tanggal Waktu Berakhir',
        'Notification Update Datetime': 'Perbarui Tanggal Waktu',
        //Monitoring
        'Run Commands': 'Jalankan Perintah',
        'Pin Code': 'Kode Pin',
        'Unlock': 'Membuka kunci',
        'Set Value': 'Tetapkan Nilai',
        'Fault Alarms': 'Alarm Cacat',
        'Instantaneous Efficiency VALUE UNIT': 'Efisiensi Segera {{VALUE}} {{UNIT}}',
        'Communication Status': 'Status Komunikasi',
        'Communication Online': 'Di Talian',
        'Communication Offline': 'Off Line',
        'Equipment Status': 'Status Perangkat',
        'Equipment Running': 'Bekerja',
        'Equipment Stopped': 'Matikan',
        'Show Up to': 'Tampilkan Kuantitas Per Halaman',
        All: 'Seluruh',
        'FROM - TO of TOTAL': 'Tampilan Saat Ini{{FROM}} - {{TO}} Total{{TOTAL}}Peranti',
        //Microgrid
        'Microgrid Energy': 'Energi Mikrogrid',
        'Microgrid Revenue': 'Pendapatan Mikrogrid',
        'Microgrid Carbon': 'Karbon Mikrogrid',
        'Photovoltaic Generation': 'Generasi Fotovoltaik',
        'EV Charger Consumption': 'Konsumsi Pengisi Daya EV',
        'Load Consumption': 'Konsumsi Beban',
        'Grid Buy': 'Pembelian dari Grid',
        'Grid Sell': 'Penjualan ke Grid',
        'EV Charger': 'Kargadó di EV',
        'Heat Pump': 'Pompa Panas',
        'Photovoltaic': 'Fotovoltaik',
        'PCS Run State': 'PCS Run State',
        'PCS Unknown': 'Tidak diketahui',
        'PCS Initializing': 'Menginisialisasi',
        'PCS Standby': 'Bersiap',
        'PCS Shutdown': 'Matikan',
        'PCS Fault': 'Gagal',
        'PCS Running': 'Running',
        'Battery Power': 'Battery power',
        'Photovoltaic Power': 'Kekuatan fotovoltaik',
        'Grid Power': 'Kuasa jaringan',
        'Load Power': 'Kuat muat',
        Reporting: 'Laporan',
        Maintenance: 'Penjagaan',
        'Serial Number': 'Nomor Seri',
        Address: 'Alamat',
        'Postal Code': 'Kode Postal',
        'Rated Capacity': 'Kapasitas Dinilai',
        'Rated Power': 'Kuasa Dinilai',
        Latitude: 'Latitude',
        Longitude: 'Longitude',
        'Strategy Management': 'Manajemen strategi',
        'Charging Schedule': 'Memuatkan Schedule',
        'Charge Start Time': 'Muat Waktu Mula',
        'Charge End Time': 'Waktu Akhir Muat',
        'Discharge Start Time': 'Buang Waktu Mula',
        'Discharge End Time': 'Waktu Akhir Buan',
        'Total Rated Power': 'Nilai Daya Total',
        'Total Rated Capacity': 'Kapasitas Nilai Total',
        "Today's Charge": "Jumlah penagihan hari ini",
        "Today's Discharge": "Keluar hari ini",
        "Today's Generation": "Pembangkit listrik saat ini",
        'Total Fuel Consumption': 'Total Fuel Consumption',
        'Total Charge': 'Total biaya',
        'Total Discharge': 'debit total',
        'Total Generation': 'Generasi Total',
        'Total Revenue': 'Total pendapatan',
        'Total Photovoltaic Generation': 'Total Generasi Fotovoltaik',
        'Total EV Charger Consumption': 'Total Konsumsi Pengisi Daya EV',
        'Total Load Consumption': 'Total Konsumsi Beban',
        'Total Grid Buy': 'Total Pembelian dari Grid',
        'Total Grid Sell': 'Total Penjualan ke Grid',
        'Total Efficiency': 'Efisiensi Total',
        'Discharge Achievement Rate': 'Tingkat Pencapaian Pelepasan',
        // Revenue Indicator
        "Today's Cost": "Today's Cost",
        "Today's Income": "Today's Income",
        "Total Cost": "Total Cost",
        "Total Income": "Total Income",
        "Today's Revenue": "Today's Revenue",

        'Revenue Ranking': 'Peringkat pendapatan',
        'Efficiency Ranking': 'Peringkat efisiensi',
        'Charge Ranking': 'Peringkat kapasitas pengisian daya',
        'Discharge Ranking': 'Peringkat pelepasan',
        'Number of Microgrids': 'Jumlah microgrid',
        'Number of Power Stations': 'Jumlah pembangkit listrik',
        'Microgrid List': 'Daftar Mikrogrid',
        'Select Microgrid': 'Pilih Mikrogrid',
        'Previous Page': 'Halaman sebelumnya',
        'Next Page': 'Halaman selanjutnya',
        '7 Days': '7 hari',
        'Charge UNIT': 'Mengenakan biaya {{UNIT}}',
        'Discharge UNIT': 'memulangkan {{UNIT}}',
        'Generation UNIT': 'menghasilkan listrik {{UNIT}}',
        'Energy Indicator': 'indeks energi',
        'Revenue Indicator': 'Indikator hasil',
        'Carbon Indicator': 'indeks karbon',

        // Energy Storage Power Station
        'Battery Operating State': 'Status Operasi Bateri',
        'Battery State': 'Status Bateri',
        'Battery Unknown': 'Tidak diketahui',
        'Battery Stopped': 'Berhenti',
        'Battery Reserved': 'Reserved', // 0
        'Battery Fault': 'Gagal', // 1
        'Battery Warning': 'Peringatan', // 2
        'Battery Standby': 'Bersiap', // 3
        'Battery Prohibit DisCharging': 'Melarangkan Memotong', // 4
        'Battery Prohibit Charging': 'Melarangkan Memuatkan', // 5
        'Battery Normal': 'Normal', // 6
        'Battery Charging': 'Memuatkan', // 7
        'Battery Discharging': 'Selama pembebasan', // 8
        'Battery Idle': 'Idle', // 9
        'Phase of Lifecycle': 'Tahap Sepeda Hidup',
        'Use Phase': 'Gunakan Tahap',
        'Commissioning Phase': 'Fase Komisionasi',
        'Commissioning Date': 'Commissioning Date',
        'Installation Phase': 'Tahap Instalasi',
        'Device Status': 'Status Perangkat',
        'Basic Information': 'Informasi Dasar',
        'Gateway': 'Gateway',
        'Grid Meter': 'Grid Meter',
        'Load Meter': 'Load Meter',
        'ESS Meter': 'ESS Meter',
        'Total Active Power': 'Total Active Power',
        'Active Power A': 'Active Power A',
        'Active Power B': 'Active Power B',
        'Active Power C': 'Active Power C',
        'Total Reactive Power': 'Total Reactive Power',
        'Reactive Power A': 'Reactive Power A',
        'Reactive Power B': 'Reactive Power B',
        'Reactive Power C': 'Reactive Power C',
        'Total Apparent Power': 'Total Apparent Power',
        'Apparent Power A': 'Apparent Power A',
        'Apparent Power B': 'Apparent Power B',
        'Apparent Power C': 'Apparent Power C',
        'Total Power Factor': 'Total Power Factor',
        'Active Energy Import': 'Active Energy Import',
        'Active Energy Export': 'Active Energy Export',
        'Active Energy Net': 'Active Energy Net',

        'Generator': 'Generator',

        // Photovoltaic Power Station
        'Invertor': 'inverter',
        'Invertor Run State': 'Run State',
        'Invertor Unknown': 'Tidak diketahui',
        'Invertor Initializing': 'Menginisialisasi',
        'Invertor Standby': 'Bersiap',
        'Invertor Shutdown': 'Matikan',
        'Invertor Fault': 'Gagal',
        'Invertor Running': 'Running',

        //Advanced Reporting & Knowledge Base
        'Created Datetime': 'Waktu Generasi',
        'File Format': 'Format Berkas',
        'File Size': 'Ukuran Berkas',
        Uploader: 'Penguasa',
        'Upload Datetime': 'Waktu Pengiriman',
        //Error
        "The page you're looking for is not found": 'Halaman Yang Anda Cari Tidak Ada',
        "Make sure the address is correct and that the page hasn't moved":
            'Silakan Konfirmasi Bahwa Alamat Benar Dan Halaman Belum Dipindahkan',
        'If you think this is a mistake,': 'Jika Anda Berpikir Ini Adalah Kesalahan,',
        'contact us': 'Hubungi Kami',
        'Take me home': 'Bawa Aku Kembali Ke Halaman Rumah',
        'Whoops, something went wrong!': 'Oh, Ada Kesalahan!',
        'Try refreshing the page, or going back and attempting the action again':
            'Silakan Coba Menyegarkan Halaman, Atau Kembali Dan Coba Melakukan Operasi Ini Lagi',
        'If this problem persists,': 'Jika Masalah Terus Berlangsung,',
        'Captcha Error': 'Galat Kode Verifikasi',
        'Confirm Password Error': 'Dua Kata Sandi Tidak Cocok',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'Sepertinya Anda Mengklik Pada Sambungan Sandi Reset Tidak Valid. Silakan Coba Lagi。',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'Sepertinya Kau Mengklik Pada Link Pendaftaran Rekening Yang Tidak Valid. Silakan Coba Lagi。',
        //Tenant Bill
        'Lease Contract Number': 'Nomor Kontrak Sewa',
        Download: 'Download',
        Print: 'Mencetak',
        'Payment Notice': 'Pengumuman Pembayaran',
        'Bill To': 'Ke',
        'Bill Number': 'Nomor Faktur',
        'Bill Date': 'Tanggal Pernyataan',
        'Payment Due Date': 'Tarikh Tarikh Pembayaran',
        'Amount Payable': 'Jumlah Yang Dapat Dibayar',
        'Billing Period Start': 'Tanggal Awal Periode Penyelesaian',
        'Billing Period End': 'Tanggal Akhir Periode Penyelesaian',
        Quantity: 'Jumlah',
        Price: 'Harga',
        Unit: 'Unit',
        Amount: 'Uang',
        Subtotal: 'Subtotal',
        'VAT Output Tax': 'Pajak Output Pajak Nilai Tambahan',
        'Total Amount Payable': 'Jumlah Yang Harus Dibayar',
        'Please make sure to pay on or before the payment due date above':
            'Silakan Pastikan Pembayaran Dilakukan Pada Atau Sebelum Tanggal Pembayaran Yang Disebutkan Di Atas',
        'Send money to the following account': 'Pengiriman Ke Akun Berikutnya',
        'Account Name': 'Title Of Account',
        'Bank Name': 'Bank Membuka',
        'Bank Address': 'Alamat Bank',
        'RMB Account': 'Akaun RMB',
        // button
        'Toggle Navigation': 'Tukar Navigasi',
        // working calendar
        'Working Days': 'Minggu',
        'Non Working Days': 'Hari Tidak Bekerja',
        'Select Row': 'Silakan Pilih Baris Data Untuk Beroperasi',
        // Offline Meter Input
        'Daily Value': 'Data Sehari',
        Date: 'Tanggal',
        'Successfully Saved': 'Successfully Saved',
        'Previous Data Is Empty': 'Data Sebelumnya Kosong',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Sesi Administrator Tidak Ada',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Sesi Administrator Telah Tamat Waktu',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Laporan Lanjutan Tidak Ada',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': 'Permintaan Galat',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER':
            'Tidak Dapat Menetapkan Tabel Ukuran Yang Sudah Ditetapkan Sebagai Tabel Bawah Sebagai Tabel Total',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Perangkat Kombinasi Dan Hubungan Perangkat Sudah Ada',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Perangkat Kombinasi Dan Hubungan Perangkat Tidak Ada',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Hubungan Antara Peralatan Kombinasi Dan Meter Sudah Ada',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Hubungan Antara Peralatan Kombinasi Dan Meter Tidak Ada',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nama Perangkat Kombinasi Sudah Digunakan',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Perangkat Kombinasi Tidak Ada',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS':
            'Perangkat Kombinasi Dan Hubungan Meja Luar Talian Sudah Ada',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND':
            'Hubungan Antara Perangkat Kombinasi Dan Tabel Offline Tidak Ada',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE':
            'Nama Parameter Yang Berhubungan Dengan Perangkat Kombinasi Sudah Digunakan',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH':
            'Parameter Yang Berhubungan Dengan Perangkat Kombinasi Tidak Ada Atau Tidak Cocok',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Perangkat Kombinasi Dan Hubungan Meja Virtual Sudah Ada',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND':
            'Perangkat Kombinasi Dan Hubungan Meja Virtual Tidak Ada',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not  found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Nama Kontak Sudah Digunakan',
        'API.CONTACT_NOT_FOUND': 'Kontak Tidak Ada',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'ID Luar Pusat Biaya Sudah Ada',
        'API.COST_CENTER_NAME_EXISTS': 'Nama Pusat Biaya Sudah Ada',
        'API.COST_CENTER_NOT_FOUND': 'Pusat Biaya Tidak Ada',
        'API.COST_FILE_NOT_FOUND': 'Berkas Biaya Tidak Ada',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Nama Sumber Data Sudah Digunakan',
        'API.DATA_SOURCE_NOT_FOUND': 'Sumber Data Tidak Ada',
        'API.DATABASE_ERROR': 'Galat Pangkalan Data',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Tanggal Sudah Ada Dalam Kalender Kerja',
        'API.DATE_LOCAL_NOT_FOUND': 'Tanggal Lokal Tidak Ditemukan',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Nama Sirkuit Distribusi Sudah Digunakan',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Sirkuit Distribusi Tidak Ada',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Sirkuit Distribusi Dan Hubungan Titik Sudah Ada',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Hubungan Antara Sirkuit Distribusi Dan Titik Tidak Ada',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Nama Sistem Distribusi Sudah Digunakan',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Sistem Distribusi Tidak Ada',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': 'Email Sudah Digunakan',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'Pesan Surel Tidak Ada',
        'API.EMAIL_NOT_FOUND': 'Email Tidak Ada',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Hos Server Surat Sudah Digunakan',
        'API.EMAIL_SERVER_NOT_FOUND': 'Hos Server Surat Tidak Ada',
        'API.EMPTY_VARIABLES_ARRAY': 'Array Variabel Kosong',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Nama Klasifikasi Energi Sudah Digunakan',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Klasifikasi Energi Tidak Ada',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Klasifikasi Energi Telah Digunakan Dalam Sub Kategori Energi',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Klasifikasi Energi Telah Digunakan Dalam Tabel Pengukuran',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Klasifikasi Energi Yang Digunakan Dalam Tabel Offline',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Klasifikasi Energi Telah Digunakan Dalam Tarif',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Klasifikasi Energi Sudah Digunakan Dalam Tabel Virtual',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Link Grafik Aliran Energi Telah Digunakan',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Link Grafik Aliran Energi Tidak Ada Atau Tidak Cocok',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Nama grafik aliran energi sudah digunakan',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Nod grafik aliran energi sudah digunakan',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Nod grafik aliran energi tidak ada atau tidak cocok',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Diagram aliran energi tidak ada',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Subitem energi tidak termasuk kategori energi',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Subitem energi tidak termasuk kategori energi',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Subitem energi digunakan',
        'API.ENERGY_ITEM_NOT_FOUND': 'Subitem energi tidak ada',
        'API.ENERGY_ITEM_USED_IN_METER': 'Subitem energi telah digunakan dalam tabel pengukuran',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Subitem energi telah digunakan dalam tabel offline',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Subitem energi sudah digunakan dalam tabel virtual',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Hubungan antara peralatan dan meter sudah ada',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Hubungan antara peralatan dan meter tidak ada',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nama perangkat sudah digunakan',
        'API.EQUIPMENT_NOT_FOUND': 'Peranti tidak ada',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Hubungan antara perangkat dan tabel luar talian sudah ada',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Hubungan antara perangkat dan tabel luar talian tidak ada',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Nama parameter terkait perangkat telah digunakan',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parameter terkait perangkat tidak ada atau tidak cocok',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Hubungan antara perangkat dan meja virtual sudah ada',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Hubungan antara perangkat dan meja virtual tidak ada',
        'API.ERROR': 'Kesalahan',
        'API.EXCEPTION': 'Abnormal',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Fail biaya pemulihan gagal',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Gagal memulihkan berkas pengetahuan',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Gagal memulihkan berkas tabel luar talian',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Gagal menyimpan berkas tabel offline',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Gagal mengunggah berkas biaya',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Gagal mengunggah berkas pengetahuan',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Gagal mengunggah berkas tabel luar talian',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Nama gerbang sudah digunakan',
        'API.GATEWAY_NOT_FOUND': 'Gateway tidak ada',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': 'Tidak valid ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': 'Alamat tidak valid',
        'API.INVALID_ADDRESS_VALUE': 'Nilai alamat tidak valid',
        'API.INVALID_ADVANCED_REPORT_ID': 'ID laporan maju tidak valid',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': 'Nilai area tidak valid',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Waktu akhir periode dasar tidak valid',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Waktu awal periode dasar tidak valid',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': 'Rata Baud tidak valid',
        'API.INVALID_BUILDINGS_VALUE': 'Nilai bangunan tidak valid',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': 'Jenis tidak valid',
        'API.INVALID_CHANNEL': 'Saluran tidak valid',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'ID perangkat kombinasi tidak valid',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Nama perangkat kombinasi tidak valid',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'ID parameter berkaitan dengan perangkat kombinasi tidak valid',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME':
            'Nama parameter berkaitan dengan perangkat kombinasi tidak valid',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE':
            'Tipe parameter berkaitan dengan perangkat kombinasi tidak valid',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'UUID perangkat kombinasi tidak valid',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': 'Koneksi tidak valid',
        'API.INVALID_CONSTANT_VALUE': 'Nilai konstan tidak valid',
        'API.INVALID_CONTACT_ID': 'ID kontak tidak valid',
        'API.INVALID_CONTACT_NAME': 'Nama kontak tidak valid',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': 'ID pusat biaya tidak valid',
        'API.INVALID_COST_FILE_ID': 'ID berkas biaya tidak valid',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': 'ID sumber data tidak valid',
        'API.INVALID_DATA_SOURCE_NAME': 'Nama sumber data tidak valid',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Protokol sumber data tidak valid',
        'API.INVALID_DATE_LOCAL': 'Tarikh lokal tidak valid',
        'API.INVALID_DENOMINATOR_METER_UUID': 'UUID ukuran standar tidak valid',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': 'Nama paparan tidak valid',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'ID sirkuit distribusi tidak valid',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Nama sirkuit distribusi tidak valid',
        'API.INVALID_DISTRIBUTION_ROOM': 'Ruangan distribusi tidak valid',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'ID sistem distribusi tidak valid',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Nama sistem distribusi tidak valid',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': 'Kotak surat tidak valid',
        'API.INVALID_EMAIL_MESSAGE_ID': 'ID email tidak valid',
        'API.INVALID_EMAIL_SERVER_HOST': 'Hos server email tidak valid',
        'API.INVALID_EMAIL_SERVER_ID': 'ID server email tidak valid',
        'API.INVALID_END_DATE_FORMAT': 'Format tanggal akhir tidak valid',
        'API.INVALID_END_DATETIME': 'Tarikh akhir tidak valid',
        'API.INVALID_ENERGY_CATEGORY_ID': 'ID klasifikasi energi tidak valid',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Nama klasifikasi energi tidak valid',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'ID Graf Aliran Energi tidak valid',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'ID Link Graf Aliran Energi tidak valid',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Nama diagram aliran energi tidak valid',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'ID Node Graf Aliran Energi tidak valid',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Nama Node Graf Aliran Energi tidak valid',
        'API.INVALID_ENERGY_ITEM_ID': 'ID sub item energi tidak valid',
        'API.INVALID_ENERGY_ITEM_NAME': 'Nama sub item energi tidak valid',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Ekspresi tidak valid dalam ekspresi',
        'API.INVALID_EQUIPMENT_ID': 'ID perangkat tidak valid',
        'API.INVALID_EQUIPMENT_NAME': 'Nama perangkat tidak valid',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'ID parameter berkaitan perangkat tidak valid',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Nama parameter terkait perangkat tidak valid',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Tipe parameter terkait perangkat tidak valid',
        'API.INVALID_EQUIPMENT_UUID': 'UUID perangkat tidak valid',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': 'Ekspresi tidak valid',
        'API.INVALID_EXPRESSION_OBJECT': 'Objek ekspresi tidak valid',
        'API.INVALID_FDD_CODE': 'Kode kesalahan tidak valid',
        'API.INVALID_FLOORS_VALUE': 'Nilai lantai tidak valid',
        'API.INVALID_FROM_ADDR': 'Alamat tidak valid',
        'API.INVALID_GATEWAY_ID': 'ID gateway tidak valid',
        'API.INVALID_GATEWAY_NAME': 'Nama gerbang tidak valid',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Nilai batas jam tidak valid',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Nilai batas jam bawah tidak valid',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': 'Nilai manajemen tidak valid',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
        'API.INVALID_IS_COUNTED_VALUE': 'Nilai hitungan tidak valid',
        'API.INVALID_IS_ENABLED': 'Tidak valid diaktifkan',
        'API.INVALID_IS_HIDDEN': 'Apakah menyembunyikan yang tidak valid',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Apakah nilai sewa tidak valid',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Apakah input tidak valid agregat',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Nilai penyewa utama tidak valid',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Apakah output tidak valid agregat',
        'API.INVALID_IS_OUTPUT_VALUE': 'Apakah output tidak valid agregat',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': 'Apakah menyimpan nilai trend yang tidak valid',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Nilai titik virtual tidak valid',
        'API.INVALID_KGCE': 'Koefisien batubara standar kilogram tidak valid',
        'API.INVALID_KGCO2E': 'Koefisien emisi dioksida karbon kilogram tidak valid',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'ID berkas pengetahuan tidak valid',
        'API.INVALID_LATITUDE_VALUE': 'Nilai latitud tidak valid',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Nomor sewa tidak valid',
        'API.INVALID_LONGITUDE_VALUE': 'Nilai longitud tidak valid',
        'API.INVALID_LOW_LIMIT_VALUE': 'Nilai batas bawah tidak valid',
        'API.INVALID_MASTER_METER_ID': 'ID meter total tidak valid',
        'API.INVALID_MENU_ID': 'ID menu tidak valid',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': 'Templat pesan tidak valid',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': 'ID meter tidak valid',
        'API.INVALID_METER_NAME': 'Nama meter tidak valid',
        'API.INVALID_METER_UUID': 'UUID ukuran tidak valid',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Nilai nama tidak valid',
        'API.INVALID_NEW_PASSWORD': 'Kata sandi baru tidak valid',
        'API.INVALID_NON_WORKING_DAY_ID': 'ID hari tidak bekerja tidak valid',
        'API.INVALID_NOTIFICATION_ID': 'ID pemberitahuan tidak valid',
        'API.INVALID_NUMERATOR_METER_UUID': 'UUID tabel numerator tidak valid',
        'API.INVALID_OBJECT_TYPE': 'Jenis objek tidak valid',
        'API.INVALID_OFFLINE_METER_DATA': 'Data tabel offline tidak valid',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'ID berkas tabel luar talian tidak valid',
        'API.INVALID_OFFLINE_METER_ID': 'ID tabel luar talian tidak valid',
        'API.INVALID_OFFLINE_METER_NAME': 'Nama tabel luar talian tidak valid',
        'API.INVALID_OFFLINE_METER_UUID': 'UUID tabel luar talian tidak valid',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
        'API.INVALID_OLD_PASSWORD': 'Kata sandi lama tidak valid',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': 'ID ruang induk tidak valid',
        'API.INVALID_PASSWORD': 'Kata sandi tidak valid',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': 'Maksimum saat ini tidak valid',
        'API.INVALID_PEAK_LOAD': 'Muatan puncak tidak valid',
        'API.INVALID_PERIOD_TYPE': 'Tipe siklus tidak valid',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': 'ID titik data tidak valid',
        'API.INVALID_POINT_NAME': 'Nama titik data tidak valid',
        'API.INVALID_PORT': 'Port tidak valid',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': 'Prioritas tidak valid',
        'API.INVALID_PRIVILEGE': 'Keizinan tidak valid',
        'API.INVALID_PRIVILEGE_DATA': 'Data izin tidak valid',
        'API.INVALID_PRIVILEGE_ID': 'ID ijin tidak valid',
        'API.INVALID_PRIVILEGE_NAME': 'Nama ijin tidak valid',
        'API.INVALID_RATIO_VALUE': 'Nisbah variabel tidak valid',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': 'Jawaban tidak valid',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Waktu tanggal akhir periode laporan tidak valid',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Periode laporan tidak valid waktu tanggal awal',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Tidak valid membutuhkan autentikasi',
        'API.INVALID_ROOMS_VALUE': 'Nilai ruang tidak valid',
        'API.INVALID_RULE_ID': 'ID aturan tidak valid',
        'API.INVALID_RULE_NAME': 'Nama aturan tidak valid',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': 'ID sensor tidak valid',
        'API.INVALID_SENSOR_NAME': 'Nama sensor tidak valid',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_PORT': 'Nomor port seri tidak valid',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Sesi tidak valid, silakan log masuk lagi',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': 'ID workshop tidak valid',
        'API.INVALID_SHOPFLOOR_NAME': 'Nama workshop tidak valid',
        'API.INVALID_SHOPFLOOR_UUID': 'UUID workshop tidak valid',
        'API.INVALID_SOURCE_NODE_ID': 'ID node sumber tidak valid',
        'API.INVALID_SPACE_ID': 'ID ruang tidak valid',
        'API.INVALID_SPACE_NAME': 'Nama ruang tidak valid',
        'API.INVALID_SPACE_UUID': 'UUID ruang tidak valid',
        'API.INVALID_START_DATE_FORMAT': 'Format waktu awal tidak valid',
        'API.INVALID_START_DATETIME': 'Waktu awal tidak valid',
        'API.INVALID_STATUS': 'Keadaan tidak valid',
        'API.INVALID_STORE_ID': 'ID toko tidak valid',
        'API.INVALID_STORE_NAME': 'Nama toko tidak valid',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Deskripsi tipe storan tidak valid',
        'API.INVALID_STORE_TYPE_ID': 'ID tipe toko tidak valid',
        'API.INVALID_STORE_TYPE_NAME': 'Nama tipe toko tidak valid',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Kode penyimplifikasi tipe storan tidak valid',
        'API.INVALID_STORE_UUID': 'UUID toko tidak valid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': 'SVG tidak valid',
        'API.INVALID_SWITCHGEAR': 'Switchgear tidak valid',
        'API.INVALID_TARGET_NODE_ID': 'ID node target tidak valid',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Penghargaan tingkat tidak valid',
        'API.INVALID_TARIFF_ID': 'ID kadar tidak valid',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Penghargaan tingkat waktu-penggunaan tidak valid',
        'API.INVALID_TARIFF_TYPE': 'Jenis kadar tidak valid',
        'API.INVALID_TENANT_ID': 'ID penyewa tidak valid',
        'API.INVALID_TENANT_NAME': 'Nama penyewa tidak valid',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Deskripsi tipe penyewa tidak valid',
        'API.INVALID_TENANT_TYPE_ID': 'ID tipe penyewa tidak valid',
        'API.INVALID_TENANT_TYPE_NAME': 'Nama tipe penyewa tidak valid',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Kode penyimplifikasi tipe penyewa tidak valid',
        'API.INVALID_TENANT_UUID': 'UUID penyewa tidak valid',
        'API.INVALID_TEXT_MESSAGE_ID': 'ID SMS tidak valid',
        'API.INVALID_TIMEZONE_ID': 'ID zona waktu tidak valid',
        'API.INVALID_TOKEN': 'Token tidak valid',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': 'Unit ukuran tidak valid',
        'API.INVALID_UNIT_OF_PRICE': 'Unit harga tidak valid',
        'API.INVALID_UNITS': 'Unit tidak valid',
        'API.INVALID_USER_ID': 'ID pengguna tidak valid',
        'API.INVALID_USER_NAME': 'Nama pengguna tidak valid',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Nama pengguna atau email tidak valid',
        'API.INVALID_USER_PHONE': 'Nomor telepon pengguna tidak valid',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Pengguna tidak valid, silakan log masuk lagi',
        'API.INVALID_USER_UUID': 'UUID pengguna tidak valid',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': 'ID meter variabel tidak valid',
        'API.INVALID_VARIABLE_METER_TYPE': 'Tipe meter variabel tidak valid',
        'API.INVALID_VARIABLE_NAME': 'Nama variabel tidak valid',
        'API.INVALID_VERIFICATION_CODE': 'Kode verifikasi tidak valid',
        'API.INVALID_VIRTUAL_METER_ID': 'ID tabel virtual tidak valid',
        'API.INVALID_VIRTUAL_METER_NAME': 'Nama tabel virtual tidak valid',
        'API.INVALID_VIRTUAL_METER_UUID': 'UUID tabel virtual tidak valid',
        'API.INVALID_WEB_MESSAGE_ID': 'ID pesan web tidak valid',
        'API.INVALID_WECHAT_MESSAGE_ID': 'ID pesan WeChat tidak valid',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': 'ID kalender kerja tidak valid',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Nama kalender kerja tidak valid',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Tidak dapat menghapus berkas pengetahuan dari disk',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'Berkas dasar pengetahuan tidak ada',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
            'Tabel ringkasan tidak termasuk dalam kategori energi yang sama',
        'API.MASTER_METER_NOT_FOUND': 'Tabel ringkasan tidak ada',
        'API.MENU_NOT_FOUND': 'Menu tidak ada',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Nama meter sudah digunakan',
        'API.METER_NOT_FOUND': 'Meter tidak ada',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Variabel meter tidak ada',
        'API.METER_POINT_RELATION_EXISTS': 'Hubungan antara meter dan titik data sudah ada',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Hubungan antara meter dan titik data tidak ada',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS':
            'Kata sandi baru tidak dapat melebihi 100 karakter dalam panjang',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': 'Hari tidak bekerja tidak ada',
        'API.NOT_FOUND': 'Tidak ada',
        'API.NOTIFICATION_NOT_FOUND': 'Notifikasi tidak ada',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'Berkas tabel luar talian tidak ada',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Nama tabel luar talian sudah digunakan',
        'API.INVALID_OFFLINE_METER_VALUE': 'Nilai meter offline tidak valid',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Variabel tabel luar talian tidak ada',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS':
            'Kata sandi lama tidak dapat melebihi 100 karakter dalam panjang',
        'API.PARENT_SPACE_NOT_FOUND': 'Ruang orang tua tidak ada',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Panjang sandi tidak dapat melebihi 100 karakter',
        'API.PASSWORDS_MATCH': 'Kata sandi baru cocok dengan kata sandi lama',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Nama titik data sudah digunakan',
        'API.POINT_NOT_FOUND': 'Titik data tidak ada',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Nama izin sudah digunakan',
        'API.PRIVILEGE_NOT_FOUND': 'Keizinan tidak ada',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Nama aturan sudah digunakan',
        'API.RULE_NOT_FOUND': 'Aturan tidak ada',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Nama sensor sudah digunakan',
        'API.SENSOR_NOT_FOUND': 'Sensor tidak hadir',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Hubungan antara sensor dan titik data sudah ada',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Hubungan antara sensor dan titik data tidak ada',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Hubungan antara workshop dan peralatan sudah ada',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Hubungan antara workshop dan peralatan tidak ada',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Hubungan antara workshop dan meter sudah ada',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Hubungan antara workshop dan meter tidak ada',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Nama workshop sudah digunakan',
        'API.SHOPFLOOR_NOT_FOUND': 'Workshop tidak ada',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Hubungan antara workshop dan meja offline sudah ada',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Hubungan antara workshop dan meja offline tidak ada',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Hubungan antara workshop dan titik data sudah ada',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Hubungan antara workshop dan titik data tidak ada',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Hubungan antara workshop dan sensor sudah ada',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Hubungan antara workshop dan sensor tidak ada',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Hubungan antara workshop dan meja virtual sudah ada',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Hubungan antara workshop dan meja virtual tidak ada',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Hubungan kalender pekerjaan workshop sudah ada',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Hubungan antara workshop dan kalender kerja tidak ada',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': 'Nod sumber tidak ada',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Hubungan antara ruang angkasa dan perangkat kombinasi sudah ada',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND':
            'Hubungan antara ruang angkasa dan perangkat kombinasi tidak ada',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Hubungan antara ruang dan perangkat sudah ada',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Hubungan antara ruang dan peralatan tidak ada',
        'API.SPACE_METER_RELATION_EXISTS': 'Hubungan antara ruang dan meter sudah ada',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Hubungan antara ruang dan meter tidak ada',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Nama ruang sudah digunakan',
        'API.SPACE_NOT_FOUND': 'Ruang tidak ada',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Ruang tidak ada dalam keizinan',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Hubungan antara ruang dan tabel luar talian sudah ada',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Hubungan antara ruang dan tabel luar talian tidak ada',
        'API.SPACE_POINT_RELATION_EXISTS': 'Hubungan ruang dan titik data sudah ada',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Hubungan antara ruang dan titik data tidak ada',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Hubungan antara ruang angkasa dan sensor sudah ada',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Hubungan antara ruang angkasa dan sensor tidak ada',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Hubungan antara ruang angkasa dan workshop sudah ada',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Hubungan antara ruang angkasa dan workshop tidak ada',
        'API.SPACE_STORE_RELATION_EXISTS': 'Hubungan antara ruang dan toko sudah ada',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Hubungan antara ruang dan toko tidak ada',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Hubungan antara ruang angkasa dan penyewa sudah ada',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Hubungan antara ruang angkasa dan penyewa tidak ada',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Hubungan antara ruang dan meja virtual sudah ada',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Hubungan antara ruang dan meja virtual tidak ada',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Hubungan antara ruang dan kalender kerja sudah ada',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Hubungan antara ruang dan kalender kerja tidak ada',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME':
            'Waktu tanggal awal harus lebih awal dari waktunya tanggal akhir',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': 'Hubungan antara toko dan meter sudah ada',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Hubungan antara toko dan meter tidak ada',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Simpan nama yang sudah digunakan',
        'API.STORE_NOT_FOUND': 'Simpan tidak ada',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Hubungan antara toko dan meja offline sudah ada',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Hubungan antara toko dan meja offline tidak ada',
        'API.STORE_POINT_RELATION_EXISTS': 'Hubungan antara toko dan titik data sudah ada',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Hubungan antara toko dan titik data sudah ada',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Hubungan antara toko dan sensor sudah ada',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Hubungan sensor toko tidak ada',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Simpan nama tipe yang sudah digunakan',
        'API.STORE_TYPE_NOT_FOUND': 'Tipe penyimpanan tidak ada',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Simpan kode penyimplifikasi tipe yang digunakan',
        'API.STORE_TYPE_USED_IN_STORE': 'Tipe penyimpanan yang sudah digunakan dalam penyimpanan',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Hubungan antara toko dan meja virtual sudah ada',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Hubungan antara toko dan meja virtual tidak ada',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Hubungan antara toko dan kalender kerja sudah ada',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Hubungan antara toko dan kalender kerja tidak ada',
        'API.TARGET_NODE_NOT_FOUND': 'Nod sasaran tidak ada',
        'API.TARIFF_IN_USE': 'Kadar dalam penggunaan',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Rate dan pusat biaya sudah terkait',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Rate dan pusat biaya tidak terkait',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Nama kadar sudah digunakan',
        'API.TARIFF_NOT_FOUND': 'Kadar tidak ada',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
        'API.TENANT_METER_RELATION_EXISTS': 'Hubungan Tenant dan Meter sudah ada',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Hubungan antara penyewa dan meter tidak ada',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Nama yang sudah digunakan',
        'API.TENANT_NOT_FOUND': 'Tenant tidak ada',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Hubungan meja Tenant dan offline sudah ada',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Hubungan meja Tenant dan offline tidak ada',
        'API.TENANT_POINT_RELATION_EXISTS': 'Hubungan Tenant dan Data Point sudah ada',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Hubungan Tenant dan Data Point tidak ada',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Hubungan sensor Tenant sudah ada',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Hubungan sensor Tenant tidak ada',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Nama dan tipe yang sudah digunakan',
        'API.TENANT_TYPE_NOT_FOUND': 'Nama dan tipe yang sudah digunakan',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Kode penyimplifikasi tipe Tenant digunakan',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Tipe tenant sudah digunakan dalam penyewa',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Hubungan meja yang tegang dan virtual sudah ada',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Hubungan meja yang tegang dan virtual tidak ada',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Hubungan kalender tenan dan kerja sudah ada',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Hubungan kalender tegang dan kerja tidak ada',
        'API.TEXT_MESSAGE_NOT_FOUND': 'SMS tidak ditemukan',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'Periode laporan harus lebih besar dari 15 menit',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'Terkait dengan meja anak',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'Terkait dengan subspace',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'Berkait dengan parameter peralatan kombinasi',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'Terkait dengan peralatan kombinasi',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'Hubungan dengan sumber data',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'Terkait dengan diagram aliran energi',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'Berkait dengan parameter terkait peralatan',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'Terkait dengan peralatan',
        'API.THERE_IS_RELATION_WITH_METER': 'Terkait dengan tabel pengukuran',
        'API.THERE_IS_RELATION_WITH_METERS': 'Berkait dengan skala berbilang',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'Hubungan dengan tabel luar talian',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'Hubungan dengan berbagai tabel luar talian',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'Hubungan dengan tabel virtual',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'Terkait dengan sensor',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'Berkait dengan workshop',
        'API.THERE_IS_RELATION_WITH_SPACES': 'Hubungan dengan ruang',
        'API.THERE_IS_RELATION_WITH_STORES': 'Berkait dengan toko',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'Berkait dengan penyewa',
        'API.THERE_IS_RELATION_WITH_USERS': 'Terhubung dengan pengguna',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'Hubungan dengan tabel virtual',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Ada hubungan dengan Plant Daya Virtual',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'Sumber data ini sedang digunakan oleh meter',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Meter ini digunakan oleh meter virtual',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Meja luar talian ini digunakan oleh meja virtual',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'Ruang tidak dapat dihapus',
        'API.TIMEZONE_NOT_FOUND': 'Zona waktu tidak ada',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token tidak ditemukan, silakan log masuk',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'Akaun pengguna terkunci',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'Akaun pengguna telah habis',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'Nama pengguna sudah digunakan',
        'API.USER_NOT_FOUND': 'Pengguna tidak ada',
        'API.USER_PASSWORD_HAS_EXPIRED': 'Kata sandi pengguna telah habis',
        'API.USER_PRIVILEGE_NOT_FOUND': 'Tidak ditemukan keizinan pengguna',
        'API.USER_SESSION_NOT_FOUND': 'Tidak ditemukan sesi pengguna',
        'API.USER_SESSION_TIMEOUT': 'Sesi pengguna sudah habis',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'UUID pengguna tidak ada, silakan log masuk',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Nama tabel virtual sudah digunakan',
        'API.VIRTUAL_METER_NOT_FOUND': 'Tabel virtual tidak ada',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Tabel virtual untuk variabel tidak ada',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Titik data virtual seharusnya jumlah analog',
        'API.WEB_MESSAGE_NOT_FOUND': 'Informasi web tidak ada',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'Informasi WeChat tidak ada',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Nama kalender kerja sudah digunakan',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Kalender kerja tidak ada',

        MasterMeter: 'Tabel Ringkasan',
        SubMeter: 'Subtable',
        'Power Quality': 'Kualitas daya',
        'About Power Quality': 'Tentang kualitas daya',
        Category: 'Kategori',
        Type: 'Jenis',
        Limit: 'Batas',
        'Normal Limit': 'Batas normal',
        'Severe Limit': 'Batas berat',
        Compliance: 'Tingkat kepatuhan',
        'Worst Deviation': 'Deviasi terburuk',
        'Worst Time': 'Waktu terburuk',
        'Severe Exceed Count': 'Jumlah pelampauan berat',
        'Worst Unbalance': 'Ketidakseimbangan maksimum',
        Hz: 'Hz',
        voltage: 'Tegangan',
        current: 'Arus',
        frequency: 'Frekuensi',
        voltage_deviation: 'Penyimpangan tegangan',
        current_unbalance: 'Ketidakseimbangan arus',
        voltage_unbalance: 'Ketidakseimbangan tegangan',
        mean_deviation_pct: 'Penyimpangan rata-rata (%)',
        p95_abs_deviation_pct: 'Penyimpangan absolut P95 (%)',
        mean_abs_deviation_hz: 'Penyimpangan absolut rata-rata (Hz)',
        frequency_deviation: 'Penyimpangan frekuensi',
        p95_abs_deviation_hz: 'Penyimpangan absolut P95 (Hz)',
        mean_unbalance_pct: 'Ketidakseimbangan rata-rata (%)',
        p95_unbalance_pct: 'Ketidakseimbangan P95 (%)',
        count: 'Jumlah',
        min: 'Min',
        max: 'Maks',
        mean: 'Rata-rata',
        std: 'Simpangan baku',
        p5: 'P5',
        p95: 'P95'
    }
};
